import 'solid-devtools';
import './index.css';
import { render } from 'solid-js/web';
import { Route, Router } from '@solidjs/router';
import { Component, ParentProps } from 'solid-js';
import Header from './components/layout/Header.jsx';
import Footer from './components/layout/Footer.jsx';
import Home from './pages/Home.jsx';
import NotFound from './pages/NotFound.jsx';

const root = document.getElementById('root');
if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
	throw new Error(
		'Something went wrong. Did you forget to add the root element to your index.html? Or maybe the id attribute got misspelled?'
	);
}

const Main: Component = (props: ParentProps) => {
	return (
		<>
			<Header/>
			<div class='flex-grow flex-shrink-0 flex-auto flex flex-col'>
				{props.children}
			</div>
			<Footer />
		</>
	);
};

render(
	() => (
		<Router root={Main}>
			<Route path='/' component={Home} />
			<Route path='*' component={NotFound} />
		</Router>
	),
	root!
);
